import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Sales module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * No "coming soon" note. The route is gated by dept.sales in allRoutes.js.
 */
const MODULES = ["cr", "project", "app-visitors", "tasks", "dms", "epo", "kpi"];

const Sales = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-line-chart-line"
                        eyebrow="Revenue"
                        title="Sales"
                        subtitle="Pipeline, quotes, and revenue at a glance"
                        tone="amber"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Sales" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="sales" title="Sales modules" icon="ri-briefcase-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Sales;
